export const almenMedicinNiveauTokenRegex = /\[([A-E]\*?)\]/g;
